import Services from './base-services'

const service = new Services('bookUserFavorite')

export default {
    getFavoriteBooksByUser: (userId: any) => {
        return service.get(`getFavoriteBooksByUser?userId=${userId}`)
    },
    addFavoriteBookToUser: (data: any) => {
        return service.post(`addFavoriteBookToUser`, data)
    },
    deleteFavoriteBookToUser: (userId: any, bookId: any) => {
        return service.delete(`deleteFavoriteBookToUser?userId=${userId}&bookId=${bookId}`)
    },
}
